import "../../style/Home/Trending.css";
import "../../style/Home/Common.css";
import '@fontsource/inter';
import agent from "../../images/agent.jpg";
import deadwind from "../../images/deadwind.jpg";
import freddy from "../../images/freddy.jpg";
import spiderman from "../../images/spiderman.jpg";
import kgf from "../../images/kgf.jpg";
import dhadak from "../../images/dhadak.jpg";
import inception from "../../images/inception.jpg";
import extraction from "../../images/extraction.jpg";
import { Container, Row, Col } from "react-bootstrap";
import {FaRegHeart,FaPlay} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { Section } from "../styles/Section.styled";

function SeeAll(props) {
const navigate =useNavigate();

    return (
        <Section>
            <Container className="mt-100 px-100 relative pt-sm-50">
                <h3 className="text-white text-center">{props.heading}</h3>
                <hr></hr>
                <Row className="pt-3">
                    <Col className="col-lg-3 col-md-3 col-6 mb-4">
                        <div className="col-zoom">
                            <div id="main">
                                <a onClick={ ()=>navigate('/detailinfo')}><img src={agent} alt="agent" /></a>
                                <a onClick={ ()=>navigate('/detailinfo')}> <button className="movies-btn "> <FaPlay /></button></a>
                                <button className="movies-btn d-block d-lg-none d-md-none"><FaPlay /></button>
                                <div id="sub" className="d-none d-lg-block d-md-block">
                                    <div className="d-flex justify-content-between p-3">
                                        <div>
                                            <h5 className="text-white mb-0">Agent</h5>
                                            <div className="extra-small-content">
                                                <p className=""> 
                                                    Duration :<span className="color-orange ps-1"> 02:35:10</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <FaRegHeart className="color-orange font-30 pt-2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="col-lg-3 col-md-3 col-6 mb-4">
                        <div className="col-zoom">
                            <div id="main">
                                <a onClick={ ()=>navigate('/detailinfo')}><img src={spiderman} alt="spiderman" /></a>
                                <a onClick={ ()=>navigate('/detailinfo')}> <button className="movies-btn "><FaPlay /></button></a>
                                <button className="movies-btn d-block d-lg-none d-md-none"><FaPlay /></button>
                                <div id="sub" className="d-none d-lg-block d-md-block">
                                    <div className="d-flex justify-content-between p-3">
                                        <div>
                                            <h5 className="text-white mb-0">Spider-Man</h5>
                                            <div className="extra-small-content">
                                                <p className="">
                                                    Duration :<span className="color-orange ps-1">02:35:10</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <FaRegHeart className="color-orange font-30 pt-2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="col-lg-3 col-md-3 col-6 mb-4">
                        <div className="col-zoom">
                            <div id="main">
                                <a onClick={ ()=>navigate('/detailinfo')}><img src={kgf} alt="kgf" /></a>
                                <a onClick={ ()=>navigate('/detailinfo')}> <button className="movies-btn "><FaPlay /></button></a>
                                <button className="movies-btn d-block d-lg-none d-md-none"><FaPlay /></button>
                                <div id="sub" className="d-none d-lg-block d-md-block">
                                    <div className="d-flex justify-content-between p-3">
                                        <div>
                                            <h5 className="text-white mb-0">KGF- Chapter 2</h5>
                                            <div className="extra-small-content">
                                                <p className="">
                                                    Duration :<span className="color-orange ps-1">02:35:10</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <FaRegHeart className="color-orange font-30 pt-2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="col-lg-3 col-md-3 col-6 mb-4">
                        <div className="col-zoom">
                            <div id="main">
                                <a onClick={ ()=>navigate('/detailinfo')}><img src={deadwind} alt="deadwind" /></a>
                                <a onClick={ ()=>navigate('/detailinfo')}> <button className="movies-btn "><FaPlay /></button></a>
                                <button className="movies-btn d-block d-lg-none d-md-none"><FaPlay /></button>
                                <div id="sub" className="d-none d-lg-block d-md-block">
                                    <div className="d-flex justify-content-between p-3">
                                        <div>
                                            <h5 className="text-white mb-0">Deadwind</h5>
                                            <div className="extra-small-content">
                                                <p className="">
                                                    Duration :<span className="color-orange ps-1">02:35:10</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <FaRegHeart className="color-orange font-30 pt-2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>   
                <Row className="pt-3">
                    <Col className="col-lg-3 col-md-3 col-6 mb-4">
                        <div className="col-zoom">
                            <div id="main">
                                <a onClick={ ()=>navigate('/detailinfo')}><img src={freddy} alt="freddy" /></a>
                                <a onClick={ ()=>navigate('/detailinfo')}> <button className="movies-btn "> <FaPlay /></button></a>
                                <button className="movies-btn d-block d-lg-none d-md-none"><FaPlay /></button>
                                <div id="sub" className="d-none d-lg-block d-md-block">
                                    <div className="d-flex justify-content-between p-3">
                                        <div>
                                            <h5 className="text-white mb-0">Freddy</h5>
                                            <div className="extra-small-content">
                                                <p className=""> 
                                                    Duration :<span className="color-orange ps-1"> 02:35:10</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <FaRegHeart className="color-orange font-30 pt-2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="col-lg-3 col-md-3 col-6 mb-4">
                        <div className="col-zoom">
                            <div id="main">
                                <a onClick={ ()=>navigate('/detailinfo')}><img src={extraction} alt="extraction" /></a>
                                <a onClick={ ()=>navigate('/detailinfo')}> <button className="movies-btn "><FaPlay /></button></a>
                                <button className="movies-btn d-block d-lg-none d-md-none"><FaPlay /></button>
                                <div id="sub" className="d-none d-lg-block d-md-block">
                                    <div className="d-flex justify-content-between p-3">
                                        <div>
                                            <h5 className="text-white mb-0">Extraction</h5>
                                            <div className="extra-small-content">
                                                <p className="">
                                                    Duration :<span className="color-orange ps-1">02:35:10</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <FaRegHeart className="color-orange font-30 pt-2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="col-lg-3 col-md-3 col-6 mb-4">
                        <div className="col-zoom">
                            <div id="main">
                                <a onClick={ ()=>navigate('/detailinfo')}><img src={dhadak} alt="dhadak" /></a>
                                <a onClick={ ()=>navigate('/detailinfo')}> <button className="movies-btn "><FaPlay /></button></a>
                                <button className="movies-btn d-block d-lg-none d-md-none"><FaPlay /></button>
                                <div id="sub" className="d-none d-lg-block d-md-block">
                                    <div className="d-flex justify-content-between p-3">
                                        <div>
                                            <h5 className="text-white mb-0">Dhadak</h5>
                                            <div className="extra-small-content">
                                                <p className="">
                                                    Duration :<span className="color-orange ps-1">02:35:10</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <FaRegHeart className="color-orange font-30 pt-2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col className="col-lg-3 col-md-3 col-6 mb-4">
                        <div className="col-zoom">
                            <div id="main">
                                <a onClick={ ()=>navigate('/detailinfo')}><img src={inception} alt="inception" /></a>
                                <a onClick={ ()=>navigate('/detailinfo')}> <button className="movies-btn "><FaPlay /></button></a>
                                <button className="movies-btn d-block d-lg-none d-md-none"><FaPlay /></button>
                                <div id="sub" className="d-none d-lg-block d-md-block">
                                    <div className="d-flex justify-content-between p-3">
                                        <div>
                                            <h5 className="text-white mb-0">Inception</h5>
                                            <div className="extra-small-content">
                                                <p className="">
                                                    Duration :<span className="color-orange ps-1">02:35:10</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <FaRegHeart className="color-orange font-30 pt-2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Section>
    );
}
export default SeeAll;
